<template>
  <div class="container">
    <heard :title="'老年多模态多媒体语料库切分标注平台--MMSE'" />
    <div class="content" id="content">
      <div class="title">
       <!-- <el-button @click="goBack" style="background-color:#568156;border-color:#568156" class="backIcon" type="primary" icon="el-icon-arrow-left" circle size="mini"></el-button> -->
       <img src="../assets/1679386722740.jpg" class="backIcon"  @click="goBack"  alt="">
        <span style="color:#568156">简易智能精神状态检查量表（MMSE）</span> 
        <el-button
          type="primary"
          size="mini"
          class="userPotrait"
          v-if="showExport && $route.query.type"
          @click="exportPdf"
          style="background-color:#568156;border-color:#568156"
          >导出</el-button
        >
      </div>
      <div class="examTable" id="examTable">
        <div class="examUserInfo">
          <el-form ref="form"  label-width="80px" style="width:100%;display:flex;flex-wrap:wrap">
          <el-form-item label="姓名:" style="width:25%">
            <el-input
              style="width:100%"
              class="userInfo"
              placeholder="姓名"
              v-model="params.patientName"
            >
            <!-- <template slot="prepend">姓名</template> -->
            </el-input>
          </el-form-item>
          <el-form-item label="性别:" style="width:25%">
            <el-select placeholder="性别" class="userInfo" style="width:100%" v-model="params.patientSex" >
              <el-option
                v-for="item in sexoptions"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="年龄:" style="width:25%">
          <el-input-number style="width:100%" placeholder="年龄" class="userInfo" v-model="params.patientAge" :min="1" :max="200" label="年龄"></el-input-number>
          </el-form-item>
          <el-form-item label="文化程度:" style="width:25%">
          <el-select placeholder="文化程度:" class="userInfo" style="width:100%" v-model="params.patientDegree" >
            <el-option
              v-for="item in degreeOption"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
         </el-form-item>
         <el-form-item label="住址:" style="width:43%">
          <el-input
            class="userInfo"
            style="width: 100%"
            placeholder="住址"
            v-model="params.patientAddress"
          >
          </el-input>
         </el-form-item>
         <el-form-item label="初步诊断:"  style="width:43%">
          <el-input
            class="userInfo"
            style="width: 100%"
            placeholder="初步诊断"
            v-model="params.primaryDiagnosis"
          >
          </el-input>
         </el-form-item>
         <!-- <el-form-item  style="width:14%;display:flex;justify-content: space-around"> -->
          <el-button style="height:40px;width:6%;margin-left:1%" @click="goBack">取消</el-button>
          <el-button type="primary" @click="submit" v-if="!type && showExport"  style="background-color:#568156;border-color:#568156;height:40px;width:6%">{{ $route.query.id ? "更新" : "保存"}}</el-button>
         <!-- </el-form-item> -->
           </el-form>
        </div>
        <div class="body">
          <div class="body-item">
            <div class="question">
              <div class="title">定向力</div>
              <div class="subject">
                <div class="subjectItem">
                  现在是 星期几？ 几号？ 几月？ 什么季节？ 哪一年？
                </div>
                <div class="subjectItem">
                  我们现在在哪里：省？ 市？ 医院？ 科室？ 第几层楼？
                </div>
              </div>
            </div>
            <div class="achievement" style="width:200px">
              <div class="hidetitle">分数</div>
              <div class="achievementItem">
                <el-input-number   class="userInfo" v-model="point[0]['tpoints']" :min="0" :max="5" ></el-input-number>
              </div>
              <div class="achievementItem">
                <el-input-number   class="userInfo" v-model="point[1]['tpoints']" :min="0" :max="5" ></el-input-number>
              </div>
            </div>
            <div class="achievement">
              <div class="hidetitle">最高分</div>
              <div class="achievementItem">5</div>
              <div class="achievementItem">5</div>
            </div>
          </div>
          <div class="body-item">
            <div class="question">
              <div class="title">记忆力</div>
              <div class="subject">
                <div class="subjectItem">
                  现在我要说三样东西的名称，在我讲完后，请您重复一遍。请您记住这三样东西，因为几分钟后要再问您的。（请仔细说清楚，每一样东西一秒钟）。
                </div>
                <div class="subjectItem">“皮球”、“国旗”、“树木”</div>
                <div class="subjectItem">
                  请您把三样东西说一遍（以第一次答案记分）
                </div>
              </div>
            </div>
            <div class="achievement" style="width:200px">
              <div class="hidetitle">分数</div>
              <div class="achievementItem">
                <!-- <el-input v-model="point[2]['tpoints']" /> -->
                <el-input-number   class="userInfo" v-model="point[2]['tpoints']" :min="0" :max="3" ></el-input-number>
              </div>
            </div>
            <div class="achievement">
              <div class="hidetitle">最高分</div>
              <div class="achievementItem">3</div>
            </div>
          </div>
          <div class="body-item">
            <div class="question">
              <div class="title">注意力和计算力</div>
              <div class="subject">
                <div class="subjectItem">
                  请您算一算100减去7，然后从所得数目再减去7，如此一直计算下去，请您将每减一个7后答案告诉我，直到我说“停止”为止。（若错了，但下一个答案是对的，那么只记一次错误）。
                </div>
                <div class="subjectItem">
                  93      86      79     72      65  
                </div>
              </div>
            </div>
            <div class="achievement" style="width:200px">
              <div class="hidetitle">分数</div>
              <div class="achievementItem">
                <el-input-number   class="userInfo" v-model="point[3]['tpoints']" :min="0" :max="5" ></el-input-number>
                <!-- <el-input v-model="point[3]['tpoints']" /> -->
              </div>
            </div>
            <div class="achievement">
              <div class="hidetitle">最高分</div>
              <div class="achievementItem">5</div>
            </div>
          </div>
          <div class="body-item">
            <div class="question">
              <div class="title">回忆能力</div>
              <div class="subject">
                <div class="subjectItem">
                  现在请您说出刚才我让您记住的那三样东西？   
                </div>
                <div class="subjectItem">“皮球” “ 国旗”  “树木”</div>
              </div>
            </div>
            <div class="achievement" style="width:200px">
              <div class="hidetitle">分数</div>
              <div class="achievementItem">
                <el-input-number   class="userInfo" v-model="point[4]['tpoints']" :min="0" :max="3" ></el-input-number>
                <!-- <el-input v-model="point[4]['tpoints']" /> -->
              </div>
            </div>
            <div class="achievement">
              <div class="hidetitle">最高分</div>
              <div class="achievementItem">3</div>
            </div>
          </div>
          <div class="body-item">
            <div class="question">
              <div class="title">语言能力</div>
              <div class="subject">
                <div class="subjectItem">（出示手表）这个东西叫什么？</div>
                <div class="subjectItem">（出示钢笔）这个东西叫什么？</div>
                <div class="subjectItem">
                  现在我要说一句话，请您跟着我清楚的重复一遍。
                </div>
                <div class="subjectItem">“四十四只石狮子”</div>
              </div>
            </div>
            <div class="achievement" style="width:200px">
              <div class="hidetitle">分数</div>
              <div class="achievementItem">
                <el-input-number   class="userInfo" v-model="point[5]['tpoints']" :min="0" :max="1" ></el-input-number>
                <!-- <el-input v-model="point[5]['tpoints']" /> -->
              </div>
              <div class="achievementItem">
                <el-input-number   class="userInfo" v-model="point[6]['tpoints']" :min="0" :max="1" ></el-input-number>
                <!-- <el-input v-model="point[6]['tpoints']" /> -->
              </div>
              <div class="achievementItem">
                <el-input-number   class="userInfo" v-model="point[7]['tpoints']" :min="0" :max="1" ></el-input-number>
                <!-- <el-input v-model="point[7]['tpoints']" /> -->
              </div>
            </div>
            <div class="achievement">
              <div class="hidetitle">最高分</div>
              <div class="achievementItem">1</div>
              <div class="achievementItem">1</div>
              <div class="achievementItem">1</div>
            </div>
          </div>
          <div class="body-item">
            <div class="question">
              <div class="title" style="visibility: hidden">语言能力</div>
              <div class="subject">
                <div class="subjectItem">
                  我给您一张纸请您按我说的去做，现在开始：“用右手拿着这张纸，用两只手将它对折起来，放在您的大腿上”。（不要重复说明，也不要示范）
                </div>
                <div class="subjectItem">
                  请您念一念这句话，并且按它的意思去做。（见背面）
                </div>
                <div class="subjectItem">
                  您给我写一句完整的句子。（句子必须有主语、谓语、宾语）
                </div>
                <div class="subjectItem">记下所叙述句子的全文。</div>
                <div class="subjectItem">
                  （见背面）这是一张图，请您在同一张纸上照样画出来
                </div>
                <div class="subjectItem">
                  （对：两个五边形的图案，交叉处有一个四边形）
                </div>
              </div>
            </div>
            <div class="achievement" style="width:200px">
              <div class="hidetitle">分数</div>
              <div class="achievementItem">
                <el-input-number   class="userInfo" v-model="point[8]['tpoints']" :min="0" :max="3" ></el-input-number>
                <!-- <el-input v-model="point[8]['tpoints']" /> -->
              </div>
              <div class="achievementItem">
                <el-input-number   class="userInfo" v-model="point[9]['tpoints']" :min="0" :max="1" ></el-input-number>

                <!-- <el-input v-model="point[9]['tpoints']" /> -->
              </div>
              <div class="achievementItem">
                <el-input-number   class="userInfo" v-model="point[10]['tpoints']" :min="0" :max="1" ></el-input-number>

                <!-- <el-input v-model="point[10]['tpoints']" /> -->
              </div>
              <div class="achievementItem">
                <el-input-number   class="userInfo" v-model="point[11]['tpoints']" :min="0" :max="1" ></el-input-number>

                <!-- <el-input v-model="point[11]['tpoints']" /> -->
              </div>
            </div>
            <div class="achievement">
              <div class="hidetitle">最高分</div>
              <div class="achievementItem">3</div>
              <div class="achievementItem">1</div>
              <div class="achievementItem">1</div>
              <div class="achievementItem">1</div>
            </div>
          </div>
          <div class="body-item">
            <div class="question">
             <!-- <div class="left"> -->
              <img src="../assets/img76729186eab267f0.png" alt="">
             <!-- </div> -->
             <div class="right">
                <div>（任务前说明）请尽量用一些完整的句子说出图片上发生的事情。</div>
                <div style="margin-top:20px">（采集过程中）您还看到了什么？还有什么？（鼓励被试产出更多话语）</div>
             </div>
            </div>
            <div class="achievement" style="width:200px">
              <el-select size="mini" v-model="languageValue" style="margin-bottom: 10px;width:180px">
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
              <el-link size="small" v-if="count" :underline="false" type="primary" style="margin-bottom:10px" >录音时长：{{ count }}s</el-link>
              <el-link size="small" :underline="false" :disabled="startDisabled" style="margin-bottom:10px" @click="start">开始录制</el-link>
              <el-link size="small" type="danger" :disabled="endDisabled" :underline="false" @click="end" style="margin-bottom:10px">结束录制</el-link>
              <el-link size="small" v-if="uploadMsgArray.length" type="success" :disabled="endDisabled" :underline="false" @click="dialogTableVisible = true">查看录音文件</el-link>
            </div>
            <div class="achievement">
              <div class="hidetitle">分数</div>
              <div class="achievementItem">
                <el-input v-model="point[12]['tpoints']" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- <div class="btnWrap" v-if="!type && showExport">
        <el-button style="background-color:#568156;border-color:#568156;width: 130px" @click="submit" type="primary">{{
          $route.query.id ? "更新" : "保存"
        }}</el-button>
      </div> -->
    </div>
       
      <el-dialog title="提示" :visible.sync="dialogTableVisible" @close="close">
        <audio
        ref="audio"
        :src="url"
        controls
        style="width:80%"
      ></audio>
      <el-table :data="uploadMsgArray" border>
        <el-table-column  label="录音文件" >
          <template slot-scope="scoped">{{ scoped.row.file }} <i class="el-icon-download" style="color:#409EFF;cursor: pointer;" @click="downLoad(scoped.row.file)"></i></template>
        </el-table-column>
        <el-table-column  label="操作" width="310" align="center">
          <template slot-scope="scope">
            <el-link  type="primary" style="margin-right:10px" @click="play(scope.row)">播放</el-link>
            <el-link style="margin-right:10px" @click="stopPlay(scope.row)">暂停</el-link>
            <el-link style="margin-right:10px" @click="downLoadEAF(scope.row)" type="success">EAF</el-link>
            <el-link style="margin-right:10px" @click="downLoadJson(scope.row)" type="success">JSON</el-link>
             <el-link style="margin-right:10px" @click="downLoadTxt(scope.row)" type="success">文本特征</el-link>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
    <foot :show='true' ref="foot"/>
  </div>
</template>

<script>
import user from "../components/portrait.vue";
import heard from "../components/heard.vue";
import foot from "../components/footer.vue";
import { addmmse, getmmseDetail, updatemmse ,uploadFile} from "../utils/mmse";
import { mapState } from "vuex";
var recorder;
export default {
  name: "VueMmse",
  data() {
    return {
      options: [{
          value: 'cn',
          label: '中文'
        }, {
          value: 'cn_cantonese',
          label: '粤语'
        }, {
          value: 'cn_uyghur',
          label: '维吾尔语'
        }, {
          value: 'cn_tibetan',
          label: '藏语'
        }],
        languageValue: 'cn',
      sexoptions:[
        {
          label:'男',
          value:'男'
        },
        {
          label:'女',
          value:'女'
        }
      ],
      degreeOption:[
        {
          label:'其他',
          value:'其他'
        },
        {
          label:'小学',
          value:'小学'
        },
        {
          label:'初中',
          value:'初中'
        },
        {
          label:'高中',
          value:'高中'
        },
        {
          label:'本科',
          value:'本科'
        },
        {
          label:'硕士',
          value:'硕士'
        },
        {
          label:'博士',
          value:'博士'
        }
      ],
      dialogTableVisible:false,
      startDisabled: false,
      endDisabled: false,
      uploadMsg: "",
      url:'',
      point: [
        {
          tno: "1",
          tpoints: "",
        },
        {
          tno: "2",
          tpoints: "",
        },
        {
          tno: "3",
          tpoints: "",
        },
        {
          tno: "4",
          tpoints: "",
        },
        {
          tno: "5",
          tpoints: "",
        },
        {
          tno: "6",
          tpoints: "",
        },
        {
          tno: "7",
          tpoints: "",
        },
        {
          tno: "8",
          tpoints: "",
        },
        {
          tno: "9",
          tpoints: "",
        },
        {
          tno: "10",
          tpoints: "",
        },
        {
          tno: "11",
          tpoints: "",
        },
        {
          tno: "12",
          tpoints: "",
        },
        {
          tno: "13",
          tpoints: "",
        },
      ],
      uploadMsgArray:[],
      showExport: true,
      params: {
        userId: "",
        userName: "",
        userHospital: "",
        clinicalImpression: "",
        patientName: "",
        patientSex: "",
        patientBirthday: "",
        patientAge: "",
        patientDegree: "",
        patientTelephone: "",
        patientAddress: "",
        patientBedNumber: "",
        patientAdmissionNumber: "",
        primaryDiagnosis: "",
        answerInfos: "",
        totalScore: ""
      },
      breadcrumbObj:{},
      count:0,
      timer:null
    };
  },
  computed: {
    ...mapState(["userInfo"]),
    total() {
      let total = 0;
      this.point.forEach((item) => {
        if (!item.tpoints) {
          total += 0;
        } else {
          total += item.tpoints * 1;
        }
      });
      return total;
    },
    editId() {
      return this.$route.query.id;
    },
    type() {
      return this.$route.query.type;
    },
  },
  created(){
    if(!this.userInfo.userId){
        this.$router.push({name:'index'})
        return
    }
  },
  mounted() {
    if (this.editId) {
      getmmseDetail(this.editId).then((res) => {
        this.params = res.data;
        this.uploadMsgArray = (res.data.audioFiles || []).map(item=>{
          return {
            file:item
          }
        })
        this.point = JSON.parse(res.data.answerInfos);
        console.log(this.point,'this.point')
      });
    }
  },
  beforeRouteEnter(to,from,next){
  next(vm => {
    vm.breadcrumbObj = {name:from.meta.title,path:from.path}
  })
},
beforeDestroy(){
  this.timer&&clearInterval(this.timer)
},
  methods: {
    downLoadEAF(data){
      let link = data.file.replace('.wav','.eaf')
      window.open(link,'_blank')
    },
    downLoadJson(data){
      let link = data.file.replace('.wav','.json')
      window.open(link,'_blank')
    },
     downLoadTxt(data){
      let link = data.file.replace('.wav','.txt')
      window.open(link,'_blank')
    },
    close(){
      this.stopPlay()
    },
    stopPlay(){
      this.$refs.audio.pause()
    },
    play(row) {
      this.url = row.file
      setTimeout(()=>{
        this.$refs.audio.play();
      })
    },
    start() {
      this.startDisabled = true;
      let that = this
      HZRecorder.get(function (rec) {
        recorder = rec;
        recorder.start();
        that.timer = setInterval(()=>{
          that.count++
        },1000)
      });
      
    },
    end() {
      if(!this.startDisabled){
        this.$message.warning('请先开始录音')
        return
      }
      recorder.stop();
      this.timer&&clearInterval(this.timer)
      this.count = 0
      let fd = new FormData();
      fd.append("file", recorder.getBlob());
      fd.append("language", this.languageValue);
      const loading = this.$loading({
          lock: true,
          text: '加载中...',
          spinner: 'el-icon-loading',
          background: 'rgba(255, 255, 255, 0.7)'
        });
      uploadFile(fd).then((res) => {
        this.startDisabled = false
        this.uploadMsgArray.push({
          file:res.msg
        })
        loading.close();
      });
    },
    downLoad(file){
      window.open(file,'_blank')
    },
    goBack(){
      this.$router.push(this.breadcrumbObj.path)
    },
    exportPdf() {
      this.showExport = false;
      setTimeout(() => {
        const loading = this.$loading({
          lock: true,
          text: "Loading",
          spinner: "el-icon-loading",
          backgroundColor: "hsla(0,0%,100%,.9)",
        });
        let name = `${this.params.patientName}_mmse.pdf`;
        let inpArray = Array.from(
          document.getElementsByClassName("el-input__inner")
        );
        inpArray.forEach((item) => {
          item.style.paddingTop = "7px";
        });
        this.getPdf(name, "content").then(() => {
          this.showExport = true;
          inpArray.forEach((item) => {
            loading.close();
            item.style.paddingTop = "";
          });
        });
      });
    },
    submit() {
        if(!this.editId &&  this.startDisabled){
          this.$message.warning('请先停止录音')
          return
        }
      this.$confirm("确认提交?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          this.params.userId = this.userInfo.userId;
          this.params.userName = this.userInfo.userName;
          delete this.params.currUserLevel
          delete this.params.userLevel
          // this.params.currUserLevel = this.userInfo.userLevel;
          // this.params.userLevel = this.userInfo.userLevel;
          this.params.totalScore = this.total;
          this.params.audioFiles = this.uploadMsgArray.map(item=>item.file)
          this.params.answerInfos = JSON.stringify(this.point);
          if (this.editId) {
            this.params.id = this.editId;
            delete this.params.updatedTime;
            delete this.params.updatedBy;
            delete this.params.doctorName;
            delete this.params.createdTime;
            delete this.params.createdBy;
          }
          try {
            this.editId
              ? await updatemmse(this.params)
              : await addmmse(this.params);
            this.$router.push("/user");
          } catch (error) {
            console.log(error);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
  components: {
    heard,
    foot,
    user,
  },
};
</script>
<style lang="less" scoped>
.container {
  width: 100%;
  background: #F9F9F9;
  .content {
    box-sizing: border-box;
    overflow-y: auto;
    padding: 0 60px;
    .title {
      margin: 30px 0;
      color: black;
      font-weight: bold;
      font-size: 20px;
      text-align: center;
      position: relative;
      .backIcon{
        cursor: pointer;
        position: absolute;
        left: 0;
        top: 0;
      }
      .userPotrait {
        position: absolute;
        right: 0px;
        top: 0;
      }
    }
    .examTable {
      border: 1px solid black;
      width: 100%;
      box-sizing: border-box;
      margin-bottom: 70px;
      .examUserInfo {
        padding: 15px;
        display: flex;
        flex-wrap: wrap;
        padding-bottom: 0;
        .patientSex{
          display: flex;
          align-items: center;
          justify-content: center;
        }
        .userInfo {
          text-align: left;
          margin-right: 15px;
          width: 18%;
          margin-bottom: 15px;
        }
      }
      .body {
        border-top: 1px solid black;
        .body-item {
          display: flex;
          // height: 100%;
          max-height: 300px;
          border-bottom: 1px solid black;
          &:last-child {
            border: 0;
          }
          .question {
            // flex: 1;
            width: 74%;
            display: flex;
            padding: 15px;
            visibility: visible;
            .title{
              width: 110px;
            }
            .left{
              flex: 1;
              width: 100%;
                height: 100%;
              img{
                width: auto;
                height: 100%;
              }
            }
            .right{
              flex: 1;
              display: flex;
              align-items: flex-start;
              justify-content: center;
              flex-direction: column;
            }
            .title {
              text-align: left;
              font-size: 18px;
              color: black;
              font-weight: bold;
              margin-top: 0;
            }
            .subject {
              .subjectItem {
                margin-bottom: 12px;
              }
            }
          }
        }
        .achievement {
          width: 60px;
          padding: 15px;
          flex-shrink: 0;
          border-left: 1px solid black;
          display: flex;
          justify-content: center;
          flex-direction: column;
          .hidetitle {
            text-align: center;
            margin: 10px 0;
            font-size: 18px;
            color: black;
            font-weight: bold;
          }
          .achievementItem {
            margin-bottom: 12px;
            text-align: center;
            height: 40px;
            line-height: 40px;
          }
        }
      }
    }
    .total {
      text-align: right;
      margin-bottom: 60px;
      font-size: 22px;
    }
    .btnWrap {
      display: flex;
      justify-content: center;
    }
  }
}
</style>

